/*
 * Copyright (c) 2021, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
*/

import React from 'react';

import { Container, CssBaseline, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
    signInContainer: {
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    },
    signInText: {
        fontFamily: 'GilmerBold',
        fontSize: '29px',
        marginTop: '50px'
    },
    tryAgainBtn: {
        margin: '20px',
        textTransform: "capitalize"
    },
    loaderContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
}));

function InternalServerError() {
    const classes = useStyles();

    return (
        <div>
            <CssBaseline />
            <Container maxWidth="lg" className={classes.signInContainer}>
                <div className={classes.loaderContainer}>
                    <img src="../../themes/default/images/internal-server-error.svg" />
                </div>
                <Typography className={classes.signInText}> Oops! This is embarrassing </Typography>
                <Typography>
                    Something went terribly wrong. Will you please refresh and try again.
                </Typography>
            </Container>
        </div>
    )
}

export default InternalServerError
